


import { useState, useEffect } from "react";

import Navbutton from "./Navbutton";
import "./navbar.css";

import data from "./data";

import logo from "../../assets/logo1.jpeg";
import { AiOutlineMessage } from "react-icons/ai";

const Navbar = () => {
  // Hide NAV on Scroll down
  // const [navdis, setNavdis] = useState("nav");

  // var prevScrollpos = window.pageYOffset;
  // 	window.onscroll = function() {
  // 	var currentScrollPos = window.pageYOffset;
  // 	if (prevScrollpos > currentScrollPos) {
  // 		setNavdis("nav")
  // 	}
  // 	else {
  // 		setNavdis("hidNav")
  //  }
  // 		prevScrollpos = currentScrollPos;
  // 	}

  const [ativeCategory, setAtiveCategory] = useState("");

  const sections = document.querySelectorAll("section");

  window.addEventListener("scroll", () => {
    let current = "";
    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;
      if (window.scrollY >= sectionTop - sectionHeight / 9) {
        current = section.getAttribute("id");
      }
    });

    data.forEach((lk) => {
      if (lk.link === `#${current}`) {
        setAtiveCategory(lk.link);
      } else if (lk.link === "#") {
        setAtiveCategory(lk.link);
      }
      
      else if (current === "contact" || current === "faqs") {
        setAtiveCategory("#contact");
      }
    });
  });

  const changeCategoryHandler = (activeCat) => {
    setAtiveCategory(activeCat);
  };

  useEffect(() => {
    setAtiveCategory(window.location.href);
  }, []);

  return (
    <nav>
      <div className="container nav__container">
        <a href="#about" className="nav__logo">
          <img src={logo} alt="DanTribes Logo" />
        </a>
        <div className="nav__menu" data-aos="fade-up">
          {data.map((category) => (
            <Navbutton
              onChangeCategory={() => changeCategoryHandler(category.link)}
              key={category.id}
              category={category.title}
              link={category.link}
              className={`btn cat__btn ${
                ativeCategory === category.link ? "white-nav" : "primary-nav"
              }`}
            />
          ))}
        </div>

        

      
        <a href="#contact" >
          <AiOutlineMessage className="nav__logo1"/>
        </a>
     
    
      </div>
    </nav>
  );
};

export default Navbar;
